<template>
  <div class="container-fluid" id="footer">
    <div class="container p-t-30 p-b-7">
      <!-- pc端 -->
      <div class="f-14 hidden-xs footer-box">
        <div class="row text-center">
          <div class="col-md-3 col-sm-3">
            <div style="display: flex; align-items: center;">
              <div class="tel m-r-10">
                <img src="@/assets/img/telephone.png" />
              </div>
              <div class="text-left" style="line-height: 1.5;">
                <span class="font-weight">
                  为使您的咨询和问题及时得到答复，可拨打以下技术支持电话：
                </span>

                <span class="font-weight">{{
                  footerInfo.undertakeTelephone
                }}</span>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-sm-6">
            <div class="row">
              <div
                class="col-md-6 col-sm-6 font-weight"
                style="line-height: 1.5;"
              >
                主办单位:{{ footerInfo.hostUnit }}
              </div>
              <div
                class="col-md-6 col-sm-6 font-weight"
                style="line-height: 1.5;"
              >
                承办单位:{{ footerInfo.undertakeUnit }}
              </div>
            </div>
          </div>
          <div class="col-md-3 col-sm-3">
            <div style="line-height: 1.5;">官方微信公众号</div>
          </div>
        </div>
        <div
          class="row text-center"
          style="display: flex; align-items: center;"
        >
          <div class="col-md-3 col-sm-3">
            <div style="display: flex; align-items: center;">
              <div class="tel m-r-10">
                <img src="@/assets/img/telephone.png" />
              </div>
              <div>
                <div class="text-left" style="line-height: 1.5;">
                  <span class="font-weight">
                    地址：
                  </span>

                  <span class="font-weight">{{ footerInfo.hostAddress }}</span>
                </div>
                <div class="text-left" style="line-height: 1.5;">
                  <span class="font-weight">
                    电话：
                  </span>

                  <span class="font-weight">{{
                    footerInfo.hostTelephone
                  }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-sm-6">
            <div
              class="row"
              v-if="
                footerInfo.theRelevantUnits &&
                  footerInfo.theRelevantUnits.length
              "
            >
              <div
                v-for="(item, index) in footerInfo.theRelevantUnits"
                :key="index"
                class="col-md-4 col-sm-4"
              >
                <img class="flatImg" :src="item.url" />
              </div>
              <!-- <div class="col-md-4 col-sm-4">
                <img class="img1" src="@/assets/img/footer1.png" />
              </div>
              <div class="col-md-4 col-sm-4">
                <img class="img2" src="@/assets/img/footer2.png" />
              </div>

              <div class="col-md-4 col-sm-4">
                <img class="img3" src="@/assets/img/footer3.png" />
              </div> -->
            </div>
          </div>
          <div class="col-md-3 col-sm-3">
            <img
              class="erweimaImg"
              v-if="
                footerInfo.officialWechat && footerInfo.officialWechat.length
              "
              :src="footerInfo.officialWechat[0].url"
            />
          </div>
        </div>
        <div class="row text-center m-t-15">
          <div class="col-md-3 col-sm-3 tool-color"></div>
          <!-- <div class="col-md-6 col-sm-6 tool-color">
            © {{ footerInfo.copyrightInformation }}
            {{ footerInfo.icpRegistrationNumber }}
          </div> -->
          <div class="col-md-6 col-sm-6 tool-color">
            © {{ currentYear }} {{ footerInfo.copyrightInformation }}
            {{ footerInfo.icpRegistrationNumber }}
          </div>
          <!-- <div class="col-md-3 col-sm-3 tool-color">访问量：0008745</div> -->
        </div>
      </div>

      <!-- 移动端 -->
      <div class="row f-14 footer-m-box visible-xs">
        <div class="col-xs-12">
          <div class="left-side">
            <div class="m-b-42" style="display: flex; align-items: center;">
              <div class="tel m-r-10">
                <img src="@/assets/img/telephone.png" />
              </div>
              <div class="text-left" style="line-height: 1.5;">
                <span class="font-weight f-12">
                  为使您的咨询和问题及时得到答复，可拨打以下技术支持电话：
                </span>

                <span class="font-weight f-12">{{
                  footerInfo.undertakeTelephone
                }}</span>
              </div>
            </div>
            <div class="m-b-42" style="display: flex; align-items: center;">
              <div class="tel m-r-10">
                <img src="@/assets/img/telephone.png" />
              </div>
              <div>
                <div class="text-left font-weight" style="line-height: 1.5;">
                  <span class="font-weight f-12">
                    地址：
                  </span>
                  <span class="font-weight f-12">{{
                    footerInfo.hostAddress
                  }}</span>
                </div>
                <div class="text-left font-weight" style="line-height: 1.5;">
                  <span class="font-weight f-12">
                    电话：
                  </span>
                  <span class="font-weight f-12">{{
                    footerInfo.hostTelephone
                  }}</span>
                </div>
              </div>
            </div>
            <!-- <div class="font-weight tool-color f-12 hidden-xs">
              云南银星科技有限公司提供技术支持
            </div> -->
          </div>
        </div>
        <div class="col-xs-12">
          <div class="main">
            <div class="row m-b-42">
              <div class="col-md-6 font-weight f-12" style="line-height: 1.5;">
                主办单位:{{ footerInfo.hostUnit }}
              </div>
              <div class="col-md-6 font-weight f-12" style="line-height: 1.5;">
                承办单位:{{ footerInfo.undertakeUnit }}
              </div>
            </div>
            <div
              class="row m-b-42"
              v-if="
                footerInfo.theRelevantUnits &&
                  footerInfo.theRelevantUnits.length
              "
            >
              <!-- <div class="col-md-4 col-xs-4">
                <img class="m-img1" src="@/assets/img/footer1.png" />
              </div>
              <div class="col-md-4 col-xs-4">
                <img class="m-img2" src="@/assets/img/footer2.png" />
              </div>
              <div class="col-md-4 col-xs-4">
                <img class="m-img3" src="@/assets/img/footer3.png" />
              </div> -->
              <div
                v-for="(item, index) in footerInfo.theRelevantUnits"
                :key="index"
                class="col-md-4 col-xs-4"
              >
                <img class="m-img3" :src="item.url" />
              </div>
            </div>
            <div class="font-weight tool-color text-center f-12 hidden-xs">
              © {{ footerInfo.copyrightInformation }}
              {{ footerInfo.icpRegistrationNumber }}
            </div>
          </div>
        </div>
        <div class="col-xs-12" style="display: flex;">
          <div class="right-side">
            <div class="font-weight m-b-15 f-12">微信公众号</div>
            <img
              class="m-b-10 m-img4"
              v-if="
                footerInfo.officialWechat && footerInfo.officialWechat.length
              "
              :src="footerInfo.officialWechat[0].url"
            />
            <!-- <div class="font-weight tool-color f-12 hidden-xs">
              访问量：0008745
            </div> -->
          </div>
        </div>
        <div class="col-xs-12 f-12 p-tb-9 m-t-10" style="color: #999;">
          © {{ currentYear }} {{ footerInfo.copyrightInformation }}
          {{ footerInfo.icpRegistrationNumber }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import SvgIcon from "./SvgIcon.vue";
export default {
  components: { SvgIcon },
  name: "Footer",
  data() {
    return {
      footerInfo: {},
      imgPrefix: process.env.VUE_APP_BASE_URL
    };
  },
  created() {
    this.getData();
  },
  computed: {
    currentYear() {
      let date = new Date();
      return date.getFullYear();
    }
  },
  methods: {
    //获取信息
    async getData() {
      let res = await this.$api.common.getFooterBasicInfo();
      try {
        if (res.code == 200) {
          if (res.data) {
            for (let key in res.data) {
              if (
                key == "theRelevantUnits" ||
                key == "officialWechat" ||
                key == "logo"
              ) {
                if (res.data[key]) {
                  let arr = JSON.parse(res.data[key]).map(item => {
                    item.url = this.imgPrefix + item.url;
                    return item;
                  });
                  this.$set(this.footerInfo, key, arr);
                }
                continue;
              }
              this.$set(this.footerInfo, key, res.data[key]);
            }
          }
        }
      } catch (error) {
        console.error(error);
      }
    }
  }
};
</script>
<style scoped lang="scss">
#footer {
  color: #fff;
  background-image: url("~@/assets/img/footer.png");

  .row {
    img {
      margin: auto;
    }
  }
  //尾部文字
  .tool-color {
    color: #999999;
    line-height: 1.5;
  }
  .tel {
    border-color: #ccc;
    border-radius: 50%;
    border: 0.5px solid #ccc;
    padding: 4px;
    img {
      height: 18px;
      width: 18px;
    }
  }
  .flatImg {
    width: 110px;
    height: 55px;
  }
  .erweimaImg {
    width: 127px;
    height: 127px;
  }
  .m-img1 {
    width: 32px;
    height: 33px;
  }
  .m-img2 {
    width: 74px;
    height: 31px;
  }
  .m-img3 {
    width: 70px;
    height: 30px;
  }
  .m-img4 {
    width: 84px;
    height: 84px;
  }
}

@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {
    font-size: 12px;
  }
  .copy {
    font-size: 12px;
    margin: 30px 0 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue